import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listCitiesOptions } from '../../../features/cities/queries';
import { listEventCategoriesOptions } from '../../../features/event-categories/queries';
import { EventForm } from '../../../features/events/components/event-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/events/new')({
  staticData: { breadcrumb: 'Новое' },
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(listCitiesOptions()),
      context.queryClient.ensureQueryData(listEventCategoriesOptions()),
    ]);
  },
  component: NewEventPage,
});

function NewEventPage() {
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const { data: categories } = useSuspenseQuery(listEventCategoriesOptions());
  return (
    <div>
      <PageHeader title="Новое событие" />
      <EventForm mode="create" cities={cities} categories={categories} />
    </div>
  );
}
